
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getServerLogs } from '@/api/services/servers';
import { Project, Common } from '@/types';
import { errorHandler } from '@/utils';

@Component({})
export default class ServerHistoryPage extends Vue {
  @Prop({ type: Object }) server: Project.Server;
  @Prop({ type: Object }) project: Project.Project;

  isPageLoading: boolean = true;
  logList: Project.ServerLogItem[] = [];
  logsCount: number = 0;
  error: string = '';
  isLoadingMore: boolean = false;

  getActionClass(action: Project.ModerationAction) {
    switch (action) {
      case Project.ModerationAction.APPROVE:
      case Project.ModerationAction.UNBAN: return 'green--text';

      case Project.ModerationAction.DECLINE:
      case Project.ModerationAction.BAN: return 'red--text';

      default: return 'black--text';
    }
  }
  getActionText(action: Project.ModerationAction) {
    switch (action) {
      case Project.ModerationAction.APPROVE: return 'Принят';
      case Project.ModerationAction.DECLINE: return 'Отклонен';
      case Project.ModerationAction.BAN: return 'Заблокирован';
      case Project.ModerationAction.UNBAN: return 'Разблокирован';
      default: return '';
    }
  }
  getBanText(reason: Common.BanReason) {
    switch (reason) {
      case Common.BanReason.FRAUD: return 'Мошенничество';
      case Common.BanReason.WRONG_CATEGORIES: return 'Неверные категории';
      case Common.BanReason.SPAM: return 'Спам';
      case Common.BanReason.OBSCENE: return 'Нецензурная лексика';
      case Common.BanReason.OTHER: return 'Другое';
      default: return ''
    }
  }

  async mounted() {
    const serverID = this.$route.params.id;
    this.isPageLoading = true;
    try {
      const resp = await getServerLogs(serverID, 0, 10);
      this.logList = resp.data.results;
      this.logsCount = resp.data.count;
    } catch (error) {
      const errResponse = error && error.data ? error.data : {};
      Object.keys(errResponse).forEach(it => {
        this.error = errorHandler(it, errResponse[it][0])
        console.log(errResponse)
      })
      this.error = ''
      console.log(error)
    } finally {
      this.isPageLoading = false;
    }
  }
}
